import {
  Table,
  message,
  Button,
  Row,
  Col,
  Image,
  Switch,
  Space,
  Tag
} from "antd";

import {
  EditOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined
} from "@ant-design/icons";

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchProps from "../../../component/SearchProps";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";

export default function CategoryManage() {
  const [categories, setCategories] =
    useState([]);

  const [saving, setSaving] =
    useState(false);

  const fetchCategories = async () => {
    try {
      const res = await axiosInstance.get(
        "/category/getAllAdminHome"
      );

      setCategories(
        res?.data?.data || []
      );
    } catch (_) {
      message.error(
        "Không tải được danh mục!"
      );
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const save = async (next) => {
    try {
      setSaving(true);

      const normalized =
        next.map((item, index) => ({
          ...item,
          home_order: index + 1
        }));

      setCategories(normalized);

      await axiosInstance.post(
        "/category/updateHomeConfig",
        {
          items: normalized.map(
            (item) => ({
              category_id:
                item.category_id,
              home_visible:
                Number(
                  item.home_visible
                ) === 0
                  ? 0
                  : 1
            })
          )
        }
      );
    } catch (_) {
      message.error(
        "Không lưu được thay đổi!"
      );

      await fetchCategories();
    } finally {
      setSaving(false);
    }
  };

  const move = async (
    index,
    direction
  ) => {
    if (saving) return;

    const target =
      index + direction;

    if (
      target < 0 ||
      target >= categories.length
    ) {
      return;
    }

    const next = [...categories];

    [
      next[index],
      next[target]
    ] = [
      next[target],
      next[index]
    ];

    await save(next);
  };

  const toggle = async (
    record,
    checked
  ) => {
    const next =
      categories.map((item) =>
        item.category_id ===
        record.category_id
          ? {
              ...item,
              home_visible:
                checked ? 1 : 0
            }
          : item
      );

    await save(next);

    message.success(
      checked
        ? "Đã hiện trên trang chủ"
        : "Đã ẩn khỏi trang chủ"
    );
  };

  const columns = [
    {
      title: "Thứ tự trang chủ",
      width: 170,
      render: (_, record, index) => (
        <Space>
          <Tag color="blue">
            {index + 1}
          </Tag>

          <Button
            size="small"
            icon={<ArrowUpOutlined />}
            disabled={
              index === 0 || saving
            }
            onClick={() =>
              move(index, -1)
            }
          />

          <Button
            size="small"
            icon={<ArrowDownOutlined />}
            disabled={
              index ===
                categories.length - 1 ||
              saving
            }
            onClick={() =>
              move(index, 1)
            }
          />
        </Space>
      )
    },

    {
      title: "Hiện trang chủ",
      width: 130,
      render: (_, record) => (
        <Switch
          checked={
            Number(
              record.home_visible
            ) !== 0
          }
          onChange={(checked) =>
            toggle(
              record,
              checked
            )
          }
        />
      )
    },

    {
      title: "ID",
      dataIndex: "category_id",
      width: 80
    },

    {
      title: "Tên",
      dataIndex: "category_name",
      width: 230,
      ...SearchProps(
        "category_name"
      )
    },

    {
      title: "Ảnh",
      dataIndex: "category_image",
      width: 150,
      render: (_, record) => (
        <Image
          src={
            record.category_image
          }
          width={90}
          height={90}
          style={{
            objectFit: "contain"
          }}
        />
      )
    },

    {
      title: "Ngày tạo",
      dataIndex: "create_at",
      width: 120,
      render: (_, record) =>
        record?.create_at &&
        dayjs(
          record.create_at
        ).isValid()
          ? dayjs(
              record.create_at
            ).format("DD/MM/YYYY")
          : "-"
    },

    {
      title: "Ngày cập nhật",
      dataIndex: "update_at",
      width: 130,
      render: (_, record) =>
        record?.update_at &&
        dayjs(
          record.update_at
        ).isValid()
          ? dayjs(
              record.update_at
            ).format("DD/MM/YYYY")
          : "-"
    },

    {
      width: 60,
      render: (_, record) => (
        <Link
          to={
            `/admin/quan-ly-danh-muc/` +
            record.category_id
          }
          className=
            "text-[var(--blue)]"
        >
          <EditOutlined />
        </Link>
      )
    }
  ];

  return (
    <>
      <Row
        gutter={10}
        align="middle"
      >
        <Col flex={1}>
          <div
            className=
              "text-[20px] font-medium"
          >
            Danh mục cha
          </div>

          <div
            style={{
              color: "#64748b",
              marginTop: 5
            }}
          >
            Hiển thị toàn bộ danh mục.
            Thứ tự tại đây là thứ tự
            ngoài trang chủ.
          </div>
        </Col>

        <Col>
          <Link
            to=
              "/admin/quan-ly-danh-muc/tao-moi"
          >
            <Button type="primary">
              Tạo
            </Button>
          </Link>
        </Col>
      </Row>

      <div
        className=
          "w-full mt-5 pb-20"
      >
        <Table
          rowKey="category_id"
          className="custom-table"
          dataSource={categories}
          columns={columns}
          pagination={false}
          loading={saving}
          scroll={{
            x: "max-content"
          }}
        />
      </div>
    </>
  );
}
